// extracted by mini-css-extract-plugin
export var standaloneTable = "_fc-0";
export var standaloneTableWithBodyFill = "_fc-1";
export var withExtraHeader = "_fc-2";